import * as React from 'react';
import { IMicrositeRecipientLinkedEntityList } from '@nkr/models/microsites/microsite-recipient-linked-entity';
import { Button, Modal } from 'react-bootstrap';
import MicrositeLinkedEntitiesList from './microsite-linked-entities-list';
import { GridReadyEvent } from 'ag-grid-community';

interface IProps {
    show: boolean,
    data: IMicrositeRecipientLinkedEntityList[],
    onGridReady: (e: GridReadyEvent) => void,
    onCancel: () => void
}

const LinkedEntitiesList: React.FunctionComponent<IProps> = (props) => {
    if (props.data == null) {
        return null;
    }

    return (
        <Modal animation={true} backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Microsite Recipient Linked Patients</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ minHeight: '20vh' }}>
                <div style={{ height: '100%', width: '100%' }}>
                    <MicrositeLinkedEntitiesList 
                        list={props.data}
                        onGridReady={props.onGridReady}
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onCancel}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default LinkedEntitiesList;